import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import Loader from "./Loader";
import { baseUrl } from "../UrlHelper/baseUrl";
import "../Styling/Banner.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  const { loading } = useSelector((state) => state.allUsers);

  const [images, setImages] = useState([]);

  // fetch all banners
  useEffect(() => {
    async function fetchImages() {
      try {
        const response = await axios.get(`${baseUrl}/banner`);
        console.log(response.data);
        setImages(response.data); // assuming API returns an array of image objects
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }

    fetchImages();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    pauseOnHover: false,
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="container rounded-4">
      <Slider {...settings} className="slick_box">
        {images.length > 0 ? (
          images.map((img, index) => (
            <div className="carousel-item" key={index}>
              <img
                className="d-block w-100 rounded-4"
                src={img.imageUrl || img.url || img.image1} // adjust based on your API response structure
                alt={`banner-${index}`}
              />
            </div>
          ))
        ) : (
          <p className="text-center">No banners available</p>
        )}
      </Slider>
    </div>
  );
};

export default Banner;
